/**
 * Helper functions for calculations (sums, etc.)
 */

/**
 * Parse a number value that might contain spaces (Norwegian formatting)
 * @param {string} value - The value to parse
 * @returns {number} The parsed number or 0 if invalid
 */
const parseNorwegianNumber = (value) => {
  if (!value || typeof value !== 'string') return 0;
  // Remove spaces (Norwegian thousand separator) before parsing
  const cleanValue = value.replace(/\s/g, '').replace(/,/g, '.');
  const num = parseInt(cleanValue);
  return isNaN(num) ? 0 : num;
};

/**
 * Calculate sums for organism groups
 */
export const calculateSumsHelper = (data, currentLocations, locations) => {
  const updated = { ...data };
  const locationsList = currentLocations.length > 0 ? currentLocations : locations;
  
  // Get actual keys used in the grid data
  const sampleDataKeys = Object.keys(data['Kiselalger_Skeletonema'] || Object.values(data).find(v => typeof v === 'object' && v !== null) || {});
  
  // Use the actual keys from gridData if they exist, otherwise fall back to locationsList
  const actualLocations = sampleDataKeys.length > 0 ? sampleDataKeys : locationsList;
  
  // Find all Kiselalger species keys dynamically (not hardcoded)
  const kiselalgerKeys = Object.keys(data).filter(key => {
    return key.startsWith('Kiselalger_') && !key.includes('SUM') && !key.includes('TOTAL');
  });
  
  actualLocations.forEach(location => {
    // Calculate Kiselalger sum from ALL kiselalger species
    const kiselalgerTotal = kiselalgerKeys.reduce((sum, key) => {
        const value = updated[key]?.[location] || '';
        if (value && value.toString().trim()) {
          // If value starts with '<', it means <5000, which should count as 0
          if (value.toString().startsWith('<')) {
            return sum + 0;
          }
          const numValue = parseNorwegianNumber(value.toString());
          return sum + numValue;
        }
        return sum;
      }, 0);
    
    if (!updated['Kiselalger_KISELALGER SUM']) {
      updated['Kiselalger_KISELALGER SUM'] = {};
    }
    updated['Kiselalger_KISELALGER SUM'][location] = kiselalgerTotal > 0 ? kiselalgerTotal.toString() : '';
  });
  
  return updated;
};
